const PageBackdrop = ({ variant = "default" }) => {
  const isHero = variant === "hero";
  const isCompact = variant === "compact";
  return (
    <>
      <style>{`
        .pb-grid {
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: 0;
          background-image:
            linear-gradient(var(--border-subtle) 1px, transparent 1px),
            linear-gradient(90deg, var(--border-subtle) 1px, transparent 1px);
          background-size: 60px 60px;
          opacity: 0.35;
        }
        .pb-grid--default {
          mask-image: radial-gradient(ellipse 80% 50% at 50% 0%, black 20%, transparent 80%);
        }
        .pb-grid--hero {
          mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, black 30%, transparent 100%);
          opacity: 0.4;
        }
        .pb-grid--compact {
          mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, black 20%, transparent 80%);
        }

        .pb-orb {
          position: fixed;
          top: -200px;
          left: 50%;
          transform: translateX(-50%);
          width: 700px;
          height: 500px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(52, 211, 153, 0.055) 0%, transparent 70%);
          pointer-events: none;
          z-index: 0;
        }
        .pb-orb--hero {
          top: -180px;
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(52, 211, 153, 0.07) 0%, transparent 70%);
        }
        .pb-orb--compact {
          top: -180px;
          width: 700px;
          height: 600px;
          background: radial-gradient(circle, rgba(52, 211, 153, 0.06) 0%, transparent 70%);
        }
      `}</style>
      <div
        className={`pb-grid pb-grid--${isHero ? "hero" : isCompact ? "compact" : "default"}`}
        aria-hidden="true"
      />
      <div
        className={`pb-orb${isHero ? " pb-orb--hero" : isCompact ? " pb-orb--compact" : ""}`}
        aria-hidden="true"
      />
    </>
  );
};

export default PageBackdrop;
